import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useStarsRating } from './StarsRating.hooks'

const StarsRating = props => {
	const [{ classes, starsRate, sectionId }] = useStarsRating(props)

	return _.map(starsRate, ({ key, percentage }) => (
		<svg
			key={key}
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="19"
			viewBox="0 0 20 19"
			className={clsx(classes.root, `${sectionId}-item-star`)}
		>
			<defs>
				<linearGradient id={key} x1="0%" y1="0%" x2="100%" y2="0%">
					{!!percentage && <stop offset={`${percentage}%`} className={classes.starFilled} />}
					<stop offset={`${percentage}%`} stopColor="transparent" />
				</linearGradient>
			</defs>
			<path
				fill={`url(#${key})`}
				className={classes.inner}
				d="m 9.0709086,0.66789176 c 0.34374,-0.816458 1.5145404,-0.816457
				1.8582404,3e-6 l 2.0288,4.81888404 c 0.145,0.3442 0.4726,0.57938
				0.8487,0.60917 l 5.266,0.41708 c 0.8923,0.07066 1.254,1.17065
				 0.5743,1.74592 l -4.0121,3.3953002 c -0.2866,0.2425 -0.4118,0.6231
				 -0.3243,0.9856 l 1.2258,5.0767 c 0.2077,0.8601 -0.7394,1.54 -1.5033,1.0791
				  l -4.5085,-2.7205 c -0.322,-0.1944 -0.7270204,-0.1944 -1.0490404,0
				  l -4.50849,2.7205 c -0.76388,0.4609 -1.71104,-0.219 -1.50336,-1.0791
				  l 1.22579,-5.0767 c 0.08756,-0.3625 -0.0376,-0.7431 -0.32417,-0.9856
				  L 0.35308862,8.2589488 c -0.67978,-0.57527 -0.3179942,-1.67526
				  0.574229,-1.74592 l 5.26606098,-0.41708 c 0.37615,-0.02979 0.7038,-0.26497 0.84871,-0.60917 z"
			/>
			<path
				className={classes.outer}
				d="M 10 0.0546875 C 9.6213703 0.054687 9.2421823 0.25974016
				9.0703125 0.66796875 L 7.0429688 5.4863281 C 6.8980589
				5.8305278 6.569509 6.0659132 6.1933594 6.0957031
				L 0.92773438 6.5136719 C 0.035512067 6.5843318 -0.3262637
				 7.6844962 0.35351562 8.2597656 L 4.3652344 11.654297 C 4.6518041
				 11.896797 4.777013 12.278125 4.6894531 12.640625 L 3.4628906
				 17.716797 C 3.2552108 18.576896 4.2029176 19.255821 4.9667969
				 18.794922 L 9.4746094 16.074219 C 9.7966291 15.879819 10.203391
				 15.879819 10.525391 16.074219 L 15.033203 18.794922 C 15.797102
				 19.255821 16.744809 18.576896 16.537109 17.716797 L 15.310547
				 12.640625 C 15.223047 12.278125 15.348166 11.896797 15.634766
				 11.654297 L 19.646484 8.2597656 C 20.326184 7.6844962 19.964565
				 6.5843318 19.072266 6.5136719 L 13.806641 6.0957031 C 13.430541
				 6.0659132 13.102031 5.8305278 12.957031 5.4863281 L 10.929688
				  0.66796875 C 10.757838 0.25973916 10.37863 0.054688
				  10 0.0546875 z M 9.9960938 1.8007812 L 11.808594 6.1953125
				  C 12.082999 6.8488694 12.702278 7.2936631 13.40625 7.3496094
				   L 18.080078 7.7207031 L 14.527344 10.738281 C 13.98786
				   11.19627 13.746172 11.925476 13.912109 12.615234
				    L 15.001953 17.138672 L 10.986328 14.707031 C 10.381431
				    14.340626 9.6185642 14.340652 9.0136719 14.707031
				     L 4.9980469 17.138672 L 6.0878906 12.615234
				     C 6.2539445 11.925476 6.0140806 11.196307
				      5.4746094 10.738281 L 1.9199219 7.7207031 L 6.59375
				       7.3496094 C 7.297721 7.2936708 7.9170622 6.8491235
				       8.1914062 6.1953125 L 9.9960938 1.8007812 z "
			/>
		</svg>
	))
}

StarsRating.propTypes = {
	rating: PropTypes.number.isRequired,
	itemKey: PropTypes.string.isRequired,
	color: PropTypes.string.isRequired,
	sectionId: PropTypes.string.isRequired,
}

export default memo(StarsRating)
